module.exports = __webpack_public_path__ + "img/gcCar_mo.a63eedac.jpg";